<template>
  <ZigzagServiceLayout
    mainTitle="Reparación del Lóbulo de la Oreja y Remodelación"
    mainDescription="Ofrecemos procedimientos simples y seguros para restaurar el equilibrio, corregir asimetrías y reparar los lóbulos de las orejas sin la necesidad de cirugía tradicional."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EarLobeRepairContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ESTÉTICA Y REPARACIÓN',
          title: 'Beneficios y Técnicas',
          subtitle: 'Restaurando la forma de manera natural y segura.',
          paragraphs: [
            "Utilizamos técnicas de otomodelación no quirúrgicas para ayudar a pacientes con lóbulos rasgados o asimétricos. Ya sea por pendientes pesados o irregularidades naturales, restauramos el volumen perfectamente.",
            "Usando rellenos dérmicos, hilos PDO o rejuvenecimiento con PRP, levantamos suavemente, corregimos ángulos y restauramos la elasticidad sin las cicatrices de la cirugía."
          ],
          list: [
            "Rellenos dérmicos para restaurar la forma y el volumen",
            "Hilos PDO / PLLA para un levantamiento no invasivo",
            "Rejuvenecimiento con PRP para restaurar la elasticidad",
            "Perfecto para lóbulos estirados u orejas prominentes"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/9rbA47bOvms'
          ]
        },
        {
          label: 'PROCEDIMIENTO',
          title: 'Detalles del Procedimiento',
          subtitle: 'Rápido, seguro y cómodo.',
          paragraphs: [
            "Nuestros tratamientos mínimamente invasivos se realizan en el consultorio con anestesia local para garantizar su comodidad. La aplicación produce resultados inmediatos.",
            "Puede esperar una recuperación muy rápida con solo una leve hinchazón que desaparece en 24 a 48 horas. También ofrecemos extirpación de quistes."
          ],
          list: [
            "Anestesia local aplicada para su comodidad",
            "Resultados inmediatos con contornos equilibrados",
            "Recuperación rápida (hinchazón leve por 24-48h)",
            "Extirpación segura de quistes menores disponible"
          ],
          image: '/images/services/earlobe-repair.png'
        }
      ]
    };
  }
};
</script>
